import {
  Card,
  CardLabel,
  CardRodape,
  CardValor,
  CardsContainer,
} from './styled';

// Faixa de indicadores das telas do menu Cobranca. Recebe a lista pronta de
// utils/billing (buildCards) — quem calcula os numeros e o useBillingList.
// Card com `onClick` vira botao e liga um filtro; sem ele e so leitura.
export default function SummaryCards({ cards }) {
  return (
    <CardsContainer>
      {(cards || []).map((item) => (
        <Card
          key={item.label}
          $color={item.cor}
          $clickable={!!item.onClick}
          $active={!!item.ativo}
          onClick={item.onClick || undefined}
          role={item.onClick ? 'button' : undefined}
          tabIndex={item.onClick ? 0 : undefined}
          aria-pressed={item.onClick ? !!item.ativo : undefined}
          onKeyDown={(event) => {
            if (!item.onClick) {
              return;
            }
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              item.onClick();
            }
          }}
        >
          <CardLabel>{item.label}</CardLabel>
          <CardValor>{item.valor}</CardValor>
          <CardRodape>{item.rodape}</CardRodape>
        </Card>
      ))}
    </CardsContainer>
  );
}
